import { render } from "./dept_list.vue?vue&type=template&id=20834828"
import script from "./dept_list.vue?vue&type=script&lang=js"
export * from "./dept_list.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__